export let VerHistorialComponent = {
    selector: 'historialDetail',
    template: require('./ver-historial.html'),
    bindings: {
        orden: '<'
    },
    controller: class {

        /*@ngInject*/
        constructor(HistorialService, $route, $location) {
            Object.assign(this, {HistorialService, $route, $location});
        }
    }
};



// WEBPACK FOOTER //
// ./client/app/historial-route/ver/ver-historial.component.js